import { FormControl, FormGroup, FormRecord } from '@angular/forms';
import { GroupMarketingPreferenceForm } from '../group-marketing-preference/group-marketing-preference-form.interface';
import { GroupMarketingPreferencesFormField } from './group-marketing-preferences-form-field.enum';

export interface GroupMarketingPreferencesForm {
  [GroupMarketingPreferencesFormField.GroupMarketingConsent]: FormControl<
    boolean | null
  >;
  [GroupMarketingPreferencesFormField.GroupMarketingPreferences]: FormRecord<
    FormGroup<GroupMarketingPreferenceForm>
  >;
}
